<template>
    <div class="catalog__filter-wrapper">
        <div class="catalog__filters" :class="{'opened-on-mobile': filterMobileOpened}">
            <div class="inner">
                <h2 class="sr-only">Filters</h2>
                <div class="form" ref="filterInner">
                    <form action="/" @submit.prevent>
                        <a href="#" class="mobile-filter-toggler" @click.prevent="showMobileFilters" role="button">Filter by</a>
                    <div class="filtering" :class="{'hide-on-mobile': !filterMobileOpened}">
                      <div class="backdrop" @click.prevent.stop="filterToggled={toggleFilterDropdownVisibility}" :class="{active: filterToggled.groupIndex}"></div>
                            <div class="mobile-filter-header">
                                <h2> Filter by </h2>
                                <a href="#" v-if="selectedFilters.length > 0" role="button" @click.prevent="clearFilterVariants" aria-label="Clear all applied filters" class="mobile-filter-clear">Clear all</a>
                                <a href="#" @click.prevent="hideMobileFilters" role="button">
                                    <i class="fa fa-times">
                                        <span class="sr-only">Close filter menu</span>
                                    </i>
                                </a>
                            </div>
                            <div v-for="filter in availableFilters"
                                 v-if="isHasEnabledFilters(filter.groupName, filter.id)" class="form-group"
                                 :class="{opened: isFilterDropdownVisible(filter.groupName, filter.id)}">
                                <label :for="'input_' + filter.groupName + '_' + filter.id" class="sr-only">Label for {{ filter.name }}</label>
                                <input type="checkbox"
                                       :id="'input_' + filter.groupName + '_' + filter.id"
                                       ref="input"
                                       aria-hidden="true"
                                       style="visibility: hidden; width: 0; height: 0; position: absolute; tab-index: -1; pointer-events: none;">
                                <div class="form-title"
                                     :class="{'has-enabled-variants': getEnabledFilterOptions(filter.groupName, filter.id).length > 0}"
                                >
                                    <a href="javascript:;"
                                       @click.prevent="toggleFilterDropdownVisibility(filter.groupName, filter.id)"
                                       @keydown.space.prevent="ev => ev.currentTarget.click()"
                                       :aria-label="'Toggle filter group ' + filter.name"
                                       role="button"
                                       :aria-expanded="isFilterDropdownVisible(filter.groupName, filter.id)"
                                    > {{ filter.name }} </a>
                                </div>
                                <div class="form-group__content">
                                    <div v-for="filterVariant in filter.values" class="checkbox-group"
                                         :class="{'d-none': isFilterDisabled(filter.groupName, filter.id, filterVariant.id)}">
                                        <input :id="'filter-' + filter.groupName + '-' + filter.id + '-' + filterVariant.id"
                                               :checked="isFilterVariantSelected(filter.groupName, filter.id, filterVariant.id)"
                                               :disabled="loading || isFilterDisabled(filter.groupName, filter.id, filterVariant.id)"
                                               @change="(e) => updateFilterVariant(e, filter.groupName, filter.id, filterVariant.id)"
                                               type="checkbox"
                                        >
                                        <label
                                            role="checkbox"
                                            :aria-checked="isFilterVariantSelected(filter.groupName, filter.id, filterVariant.id) ? 'true' : 'false'"
                                            tabindex="0"
                                            @keydown.enter="ev => ev.currentTarget.click()"
                                            @keydown.space.prevent="ev => ev.currentTarget.click()"
                                            :aria-label="(isFilterVariantSelected(filter.groupName, filter.id, filterVariant.id) ? 'Disable' : 'Enable') + 'filter: ' + filterVariant.name"
                                            :for="'filter-' + filter.groupName + '-' + filter.id + '-' + filterVariant.id"
                                        >
                                            {{ filterVariant.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sorting">
                            <label class="sr-only" for="catalogSorting" id="sort-label">Sorting</label>
                            <select v-model="order_by" aria-describedby="sort-label" id="catalogSorting">
                                <option v-for="option in catalogSortingOptions" :value="option.id">{{option.text}}</option>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="catalog__tags">
            <a @click.prevent="resetSearch" href="javascript:;" v-if="searchQuery">
                Search: {{ searchQuery }}
            </a>
            <a v-for="filter in selectedFilters" @click="removeFilterVariant(filter)" href="javascript:;" :aria-label="'Remove filter: ' + getFilterTitle(filter) " >{{ getFilterTitle(filter) }}</a>
            <a href="#" v-if="selectedFilters.length > 0" @click.prevent="clearFilterVariants" class="clear-button" role="button" aria-label="Clear all applied filters">Clear all</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
            },
            searchQuery: {
                type: String,
            },
            availableFilters: {
                type: Array,
            },
            whitelistFilters: {
                type: Array,
            },
            needUpdateFromQuery: {
                type: Boolean,
            },
            filterArrayToPostObj: {
                type: Function,
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.stickyFilters();
            })
            this.parseRouteFilters();
        },
        data: () => ({
            order_by: 'default',
            filterMobileOpened: false ,
            filterToggled: {
                groupIndex: null,
                filterIndex: null,
            },
            selectedFilters: [],
            catalogSortingOptions: [
                {
                    id: 'default',
                    text: 'Sort By',
                },
                {
                    id: 'price_low',
                    text: 'Lowest Price',
                },
                {
                    id: 'price_high',
                    text: 'Highest Price',
                },
                {
                    id: 'newest',
                    text: 'Newest Items',
                },
                {
                    id: 'best_seller',
                    text: 'Best seller',
                },
            ],
        }),
        watch: {
            'selectedFilters'() {
                this.$emit('change-filter', this.selectedFilters);
            },
            'order_by'() {
                this.$emit('change-order', this.order_by);
            },
            'needUpdateFromQuery'() {
                if (this.needUpdateFromQuery === true) {
                    this.$emit('query-updated');
                }
            }
        },
        methods: {
            resetSearch: function () {
                let query = Object.assign({}, this.$route.query);
                delete query.s;
                this.$router.replace({query});
                this.$emit('change-search');
            },
            stickyFilters() {
                if (this.$refs.filterInner) {
                    new window.Waypoint.Sticky({
                        element: this.$refs.filterInner,
                        stuckClass: 'fixed',
                        offset: this.$refs.filterInner.offsetTop,
                        handler: () => {
                            const headerSticky = document.querySelector('header .sticky-wrapper .header');
                            if (headerSticky) {
                                this.$refs.filterInner.style.top = headerSticky.offsetHeight + 'px';
                            }
                        },
                    });
                } else {
                    throw Error("filter wrapper node not found. can't make it sticky")
                }
            },
            getFilterTitle({id, value, groupName}) {
                return this.availableFilters
                    .filter(e => e.id === id && e.groupName === groupName)[0]
                    ?.values.filter(v => v.id === value)[0]
                    ?.name;
            },
            isFilterDropdownVisible(filterGroundIndex, newFilterIndex) {
                const {groupIndex, filterIndex} = this.filterToggled;

                return groupIndex === filterGroundIndex && filterIndex === newFilterIndex;
            },
            toggleFilterDropdownVisibility: function (groupIndex, filterIndex) {
                const input = this.$refs.input.filter(el => el.id === `input_${groupIndex}_${filterIndex}`)[0]
                input.checked = !input.checked

                if (this.isFilterDropdownVisible(groupIndex, filterIndex)) {
                    this.filterToggled = {groupIndex: null, filterIndex: null};
                } else {
                    this.filterToggled = {groupIndex, filterIndex};
                }
            },
            hideMobileFilters: function () {
                this.filterMobileOpened = false;
            },
            showMobileFilters: function () {
                this.filterMobileOpened = true;
            },
            updateFiltersQuery: function () {
                const { filterArrayToPostObj } = this;
                const postFilterObject = filterArrayToPostObj(this.selectedFilters);
                const filters = Object.keys(postFilterObject)
                    .map( groupName =>
                        [groupName, postFilterObject[groupName]
                            .reduce((acc, p) => ({ ...acc, ...{[p.id]: p.values} }), {})]
                    ).reduce((acc, p) => ({
                        ...acc, ...{[p[0]]: p[1]}}), {});
                const query = Object.assign({}, this.$route.query, {f: filters});

                this.$router.push({path: this.$route.path, query}).catch((e) => {});
            },
            parseRouteFilters: function () {
                if (typeof this.$route.query.f === 'undefined') {
                    return;
                }

                const valuesToArray = (obj) => Object.keys(obj).map(i => obj[i]);
                const getIDs = obj => Object
                    .keys(obj)
                    .map(i => ({ id: i, values: valuesToArray(obj[i]) }))
                    .reduce((acc, p) => ({...acc, ...p}), {});

                const query = this.$route.query.f;
                const reformatted = Object.keys(query)
                    .map(i => ( { groupName: i, ...getIDs(query[i]) }))

                reformatted.forEach(obj => {
                    obj.values.forEach(value => {
                        this.toggleFilterVariant(obj.groupName, +obj.id, +value);
                        this.$emit('change-filter', this.selectedFilters);
                        this.updateFiltersQuery();
                    })
                })
            },
            toggleFilterVariant(groupName, filterId, filterVariantId) {
                const isFilterApplied = this.selectedFilters
                    .filter(e =>
                        e.groupName === groupName &&
                        e.id === filterId &&
                        e.value === filterVariantId
                    ).length > 0;

                if (isFilterApplied) {
                    this.selectedFilters = this.selectedFilters
                        .filter(e => e.id !== filterId || e.value !== filterVariantId || e.groupName !== groupName);
                } else {
                    this.selectedFilters = [
                        ...this.selectedFilters,
                        {id: filterId, value: filterVariantId, groupName}
                    ]
                }
            },
            updateFilterVariant: function (event, groupName, filterId, filterVariantId) {
                this.page = 1;

                const isFilterApplied = !event?.target?.checked;

                if (isFilterApplied) {
                    this.selectedFilters = this.selectedFilters
                        .filter(e => e.id !== filterId || e.value !== filterVariantId || e.groupName !== groupName);
                } else {
                    this.selectedFilters = [
                        ...this.selectedFilters,
                        {id: filterId, value: filterVariantId, groupName}
                    ]
                }

                this.updateFiltersQuery();
            },
            removeFilterVariant: function ({id, value, groupName}) {
                this.selectedFilters = this.selectedFilters
                    .filter(e =>
                        e.id !== id ||
                        e.value !== value ||
                        e.groupName !== groupName);
                this.updateFiltersQuery();
            },
            clearFilterVariants() {
                this.selectedFilters = [];
                this.updateFiltersQuery();
            },
            isFilterVariantSelected: function (groupName, filterId, filterVariantId) {
                return this.selectedFilters
                    .filter(e => e.id === filterId &&
                        e.value === filterVariantId &&
                        e.groupName === groupName
                    ).length > 0
            },
            getWhiteListedObjects(groupIndex, filterIndex) {
                return this.whitelistFilters.filter(filter =>
                    filter.groupName === groupIndex &&
                    filter.id === filterIndex &&
                    filter.values.length > 0
                );
            },
            isFilterDisabled: function (groupIndex, filterIndex, valueId) {
                const filters = this.getWhiteListedObjects(groupIndex, filterIndex);

                if (filters.length === 0) {
                    return true;
                }

                return filters[0].values.filter(value => valueId === value.id).length === 0;
            },
            getEnabledFilterOptions(groupName, filterId) {
                return this.selectedFilters.filter(e => e.groupName === groupName && e.id === filterId);
            },
            isHasEnabledFilters(groupIndex, filterIndex) {
                return this.getWhiteListedObjects(groupIndex, filterIndex).length > 0;
            },
        }
    }
</script>

<style scoped lang="scss">
@media only screen and (max-width: 992px) {
  .filtering.hide-on-mobile {
    display: none;
  }
}
</style>
